import React from "react";
import { Stack, Typography } from "@mui/material";

import {
  HubHookFormInput,
  HubHookFormTimePicker,
  StationHookFormSelect,
} from "../../../components";
import { StyledHubCardStack } from "../styles";
import { useHighlightableField } from "../../../hooks";

const gap = "10px";
const columnGap = "10px";

const PartAutoclave = ({ basePath }) => {
  const { HighlightMenu, getFieldProps } = useHighlightableField();

  const p = `${basePath}.routing.0`;
  const cp = `${basePath}.config`;

  return (
    <StyledHubCardStack gap="25px">
      <Stack gap={gap}>
        <Typography variant="boldCaptionMain">Dewax Details</Typography>
        <Stack gap="25px">
          <Stack direction="row" gap={columnGap}>
            <StationHookFormSelect
              name={`${p}.stationId`}
              label="Station"
              department={3}
              {...getFieldProps(`${p}.stationId`)}
            />
            <HubHookFormTimePicker
              name={`${p}.leadTime`}
              label="Lead Time"
              placeholder="Ex. 12"
              fields={["days"]}
              required
              {...getFieldProps(`${p}.leadTime`)}
            />
            <HubHookFormTimePicker
              name={`${p}.cycleTime`}
              label="Cycle Time"
              placeholder="Ex. 0.24"
              required
              {...getFieldProps(`${p}.cycleTime`)}
            />
          </Stack>
        </Stack>
        <Stack direction="row" gap={columnGap}>
          <HubHookFormInput
            name={`${cp}.treesPerLoad`}
            label="Trees / Load"
            placeholder="Ex. 12"
            isNumber
            {...getFieldProps(`${cp}.treesPerLoad`)}
          />
          <HubHookFormInput
            name={`${cp}.dewaxedShellWeight`}
            label="Dewaxed Shell Weight"
            placeholder="Ex. 12"
            isNumber
            {...getFieldProps(`${cp}.dewaxedShellWeight`)}
          />
        </Stack>
      </Stack>
      <Stack gap={gap}>
        <Typography variant="boldCaptionMain">Autoclave Notes</Typography>
        <HubHookFormInput
          name={`${basePath}.notes`}
          label="Special Instructions"
          placeholder="Notes..."
          rows={5}
          multiline
          {...getFieldProps(`${basePath}.notes`)}
        />
      </Stack>
      {HighlightMenu}
    </StyledHubCardStack>
  );
};

export default PartAutoclave;
